<template>
  <v-footer
    :app="!$route.query.embed"
    height="69"
    style="
      border-bottom: 1px solid #dfdfdf;
      border-left: 1px solid #dfdfdf;
      border-right: 1px solid #dfdfdf;
    "
    :class="isIOS ? 'pb-16' : ''"
  >
    <v-row no-gutters justify="center">
      <v-row style="max-width: 1230px" align="center" no-gutters>
        <v-col :cols="$vuetify.breakpoint.mdAndUp ? '4' : '5'">
          <div v-if="cartProducts && cartProducts.length">
            <v-row no-gutters>
              <span class="checkout-h5 grey--text"
                >{{ summaryCart.quantity }}
                {{
                  summaryCart.quantity > 1
                    ? $t("cart.tickets").toUpperCase()
                    : $t("cart.ticket").toUpperCase()
                }}</span
              ></v-row
            >
            <v-row no-gutters>
              <span class="checkout-h3 accent--text">
                {{ summaryCart.value | currency }}</span
              >
            </v-row>
          </div>
          <span v-else class="checkout-h5 grey--text">{{
            $t("cart.nothingTickets")
          }}</span>
        </v-col>
        <v-spacer></v-spacer>
        <v-btn
          :width="$vuetify.breakpoint.mdAndUp ? '35%' : '50%'"
          rounded
          depressed
          height="40"
          color="primary"
          :disabled="cartProducts && !cartProducts.length"
          :loading="loading"
          @click="$emit('createOrder')"
          >{{ $t("cart.continue") }}</v-btn
        >
      </v-row>
    </v-row>
  </v-footer>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["cartProducts", "loading", "showSeatMap"],
  computed: {
    ...mapGetters([
      "eventDetails",
      "pdv",
      "productsTotal",
      "orderDetails",
      "lastOrderAndCart",
      "noSectorList",
      "productsDetails",
    ]),
    summaryCart() {
      let quantity = 0;
      let value = 0;
      this.cartProducts.forEach((p) => {
        p.forEach((v) => {
          quantity += v.quantidade;
          value += (v.valor + v.valor_conveniencia) * v.quantidade;
        });
      });

      return { quantity, value };
    },
    isIOS() {
      return [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform);
    },
  },
};
</script>
